import type { FC } from "react"
import { IconCheckOutline18 as Check } from "nucleo-ui-outline-18"

import { cn } from "@productlane/lib/src/cn"
import { Avatar } from "@productlane/ui"
import { CommandItem } from "@productlane/ui/src/components/internal/command"

import type { SharedFilterItemsProps } from "./types"
import { usePortalMarks } from "@/lib/use-portal-marks"
import { useThreadsFilterState } from "../threads-filter-state"

export const PortalFilterItems: FC<SharedFilterItemsProps> = ({ onSelect }) => {
	const { portalInstanceIds, addPortalInstance, removePortalInstance } =
		useThreadsFilterState()
	const marks = usePortalMarks()

	if (marks.length === 0) {
		return (
			<div className="py-4 text-center text-sm">
				This workspace runs a single portal
			</div>
		)
	}

	return (
		<>
			{marks.map((mark) => {
				const isSelected = portalInstanceIds.includes(mark.id)

				return (
					<CommandItem
						key={mark.id ?? "main"}
						value={mark.name}
						onSelect={() => {
							if (isSelected) {
								removePortalInstance(mark.id)
							} else {
								addPortalInstance(mark.id)
							}
							onSelect()
						}}
					>
						<div className="flex w-full items-center gap-2">
							<Avatar
								name={mark.name}
								image={mark.logoUrl}
								colorSeed={mark.colorSeed}
								roundness="sm"
								size="xs"
								className="flex-none"
							/>
							<span className="flex-1 truncate">{mark.name}</span>
							<Check
								className={cn("h-4 w-4 shrink-0", {
									"opacity-100": isSelected,
									"opacity-0": !isSelected,
								})}
							/>
						</div>
					</CommandItem>
				)
			})}
		</>
	)
}
